import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';

declare var $: any;

@Component({
  selector: 'app-bidashboard',
  templateUrl: './bidashboard.component.html',
  styleUrls: ['./bidashboard.component.css']
})
export class BidashboardComponent implements OnInit, OnDestroy {

  subscriptions: Subscription = new Subscription();
  id: string = '';
  iframeUrl: any;

  constructor(
    private route: ActivatedRoute,
    private sanitizer: DomSanitizer) {
    //this.baseUrl = baseUrl; 
  }

  ngOnInit() {
    this.route.params.subscribe((params) => {
      this.id = params['id'] ?? '';
      if (this.id == '') {
        // Todo: Need to redirect back to the project list
        return;
      }

      this.loadData();
    });
  }

  loadData() {
    //const url = 'https://app.powerbi.com/reportEmbed?reportId=40e4006c-929f-4d00-997c-2650b6e216ed&autoAuth=true&ctid=2d0703cb-a705-4aef-99af-fd1244540e2b';
    const url = 'https://app.powerbi.com/reportEmbed?reportId=40e4006c-929f-4d00-997c-2650b6e216ed&autoAuth=true&ctid=2d0703cb-a705-4aef-99af-fd1244540e2b&filter=project%2Fproject_number%20eq%20%27' + this.id + '%27';
    this.iframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
